// TODO FOR SAMPLES

// function freeShippingBar() {
//         $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//           dataType: 'json',
//          success: function (data) {
//           var initial_cart_total = data.total_price * 0.01;
//            var items = data.items;
//           var insurance = '';
//            $.each(items, function( index, value ) {
//              if(value.handle == 'routeins') {
//                var insurance = value.price * 0.01;
//              }
//            });

//            var cart_total = parseInt(initial_cart_total - insurance);


//            $('.free-shipping-progress-bar').attr('data-cart-total', cart_total);
//            var threshold = $('.free-shipping-progress-bar').data('cart-threshold');
//            var percentage = cart_total / threshold * 100;
//            var remaining = Math.round(threshold - cart_total);


//            if(percentage >= 100) {
//              $('.free-shipping-progress-bar .bar').css({'width': '100%'});
//              $('.free-shipping-title').html("You\'ve earned free shipping!");
//            } else {
//              $('.free-shipping-progress-bar .bar').css({'width': percentage+'%'});
//              $('.free-shipping-title').html("Spend $"+remaining+" more to get free shipping");

//            }
//          }
//          });
// }


var samples = $('.samples-list').data('samples');
var threshold = $('.samples-list').data('sample-threshold');

// function checkSamples(samples, threshold) {
//   var samplesInCart = [];
//  var cart_total_final = '';

//         $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//           dataType: 'json',
//          success: function (data) {

//            // GET THE CART TOTAL
//            var cart_total = data.total_price * 0.01;

//            // GET THE CART ITEMS
//            var products = data.items;


//             var insurance = '';
//            $.each(products, function( index, value ) {
//              if(value.handle == 'routeins') {
//                var insurance = value.price * 0.01;
//              }
//            });

//            var cart_total_final = parseInt(cart_total - insurance);


//            $.each(products, function(index, product) {
//              if($.inArray(product.id, samples) !== -1) {
//                     samplesInCart.push(product.id);
//                     console.log('sample '+product.id+' in cart');
//                $('.sample[data-product-id="'+product.id+'"]').find('button span').html('added');
//                $('.sample[data-product-id="'+product.id+'"]').find('button').attr('disabled', 'true');
//               }
//            });


//             // IF CART TOTAL IS GREATER THAN THE SAMPLES THRESHOLD SET IN THEME SETTINGS
//              if(cart_total_final > threshold  ) {
//                // SHOW THE SAMPLES WIDGET
//                   $('.samples').removeClass('hidden');

//                 if(samplesInCart.length >= 2) {

//                   // IF THE CART ALREADY HAS TWO SAMPLES IN IT
//                   $('.samples').addClass('hidden');

//                 }

//               } else {

//                  // IF BELOW THE THRESHOLD, HIDE THE SAMPLES WIDGET
//                $('.samples').addClass('hidden');

//                // REMOVE THE SAMPLES FROM THE CART


//                       var iterations = 0;
//                       var interval = setInterval(clearSamples, 1000);
//                       console.log('samples in cart = ' + samplesInCart.length);
//                       $('cart-drawer').addClass('removing-samples');
//                         function clearSamples() {
//                       // console.log('iterations ' + iterations);
//                         if (iterations >= samplesInCart.length) {
//                               clearInterval(interval);
//                               $('cart-drawer').removeClass('removing-samples');

//                         } else {

//                            $('tr.cart-item.sample').first().find('.remove-button').click();
//                         }
//                           iterations++;
//                         };
//             }

//          }
//          });

//   }

$(document).ready(function () {
  // checkSamples();
  var pricewithsign = $('product-form .product-form__submit .price-item').first().text();
  var price = pricewithsign.replace('$', '');
  var priceInt = parseInt(price);

  // CONNECT STICKY CTA QUANTITY INPUT TO PRODUCT FORM

  $('.sticky-cta .quantity__input').on('change', function () {
    var val = $(this).val();
    $('.product-form-wrapper .quantity__input').val(val);
    $('.price-item').html('$' + (priceInt * val));
  });

  $('.product .product-form-wrapper .quantity__input').on('change', function () {
    var val = $(this).val();
    $('.price-item').html('$' + (priceInt * val));
  });


  $('.sticky-cta-button').on('click', function () {
    $('.product-form__submit').click();
  });
  $('a.no-thanks').on('click', function () {
    $('.samples').addClass('hidden');
  });


  // $('.header__menu-item.top-level').mouseenter(function() {
  //            var myThis = $(this);

  //            setTimeout(function () {
  //            $('summary.header__menu-item').not($(this)).parents('details').removeAttr('open');
  //               myThis.click();
  //            }, 200);

  //        });


//   $('ul.header__submenu').mouseleave(function() {
//     var myThis = $(this);
//     setTimeout(function () {
//             myThis.prev().click();
//            myThis.prev().find('ul.header__submenu').hide();
//     }, 500);
// });

//     var options = $('select.select__select option');
// var arr = options.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
// arr.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
// options.each(function(i, o) {
//   o.value = arr[i].v;
//   $(o).text(arr[i].t);
// });

});

// Start set position of megamenu
$(document).on('click', '.header__menu-item', function () {
  var ju_Con = $('.ju_Con:visible').height();
  var header = $('sticky-header').height();
  if (ju_Con) {
    var finalHeight = ju_Con + header - 10;
  } else {
    var finalHeight = header;
  }
  $('header-menu .header__submenu').css('top', finalHeight + 'px');
});
// End set position of megamenu

// Start Mobile toggle
$(document).on('click', '.custom-menu-drawer__submenu', function () {

  $(this).next('ul').slideToggle();
  $(this).toggleClass('menu-active');

  // if($(this).parents('.menu-with-submenu-sg').find('.sg-sub-menus').hasClass('menu--active')){
  //   $('li .menu-with-submenu-sg .sg-sub-menus').removeClass('menu--active');
  //   }
  // else{
  //   $('li .menu-with-submenu-sg .sg-sub-menus').removeClass('menu--active');
  //   $(this).parents('.menu-with-submenu-sg').find('.sg-sub-menus').addClass('menu--active');
  // }
});
// End Mobile toggle

// Start Scroll Issue
var check = document.documentElement.scrollTop || document.body.scrollTop;
if (check) {
  $('#shopify-section-header').addClass('shopify-section-header-hidden shopify-section-header-sticky');
}

$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $('#shopify-section-header').addClass('shopify-section-header-hidden shopify-section-header-sticky');
  } else {
    $('#shopify-section-header').removeClass('shopify-section-header-hidden shopify-section-header-sticky');
  }
});

function setHeaderHeightVariable() {
  const announcementBar = $('.announcement-bar');
  const header = $('.header-wrapper');

  const root = document.documentElement;
  const announcementBarHeight = announcementBar ? announcementBar.height() : 0;
  const headerHeight = header ? header.height() : 0;
  let headerHeightWithAnnouncement =
    +announcementBarHeight + +headerHeight;
  root.style.setProperty("--header-height-with-announcement", headerHeightWithAnnouncement + "px");
  root.style.setProperty("--header-height", headerHeight + "px");
  root.style.setProperty("--announcement-height", announcementBarHeight + "px");
}

$(document).ready(function () {
  setHeaderHeightVariable();
  $(window).on("resize", setHeaderHeightVariable);
  setMainTopSpacing();

  checkScreenSize();
});

function setMainTopSpacing() {
  const header = $('.header-wrapper');
  const mainContent = $('main#MainContent');

  if (mainContent && header && !header.hasClass("header-wrapper--transparent")) {
    mainContent.addClass("main--top-spacing");
  }
}


function checkScreenSize() {
  var newWindowWidth = $(window).width();
  var options = ['damping', 1];


  if (newWindowWidth < 640) {

    $('.product__media-list').slick({
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplay: true,
      // autoplaySpeed: 5000,
      arrows: false,
    });


    var Scrollbar = window.Scrollbar;
    if ($('.mob-slider').length) {
      Scrollbar.init(document.querySelector('.mob-slider'));
    }


    setTimeout(rebuyScroll, 3000);

    function rebuyScroll() {
      console.log('rebuy scroll');

      if ($('body.product .rebuy-widget.widget-type-product .rebuy-product-grid').length) {
        Scrollbar.init(document.querySelector('body.product .rebuy-widget.widget-type-product .rebuy-product-grid'));
      }

    }


    if ($('.product ul.product__media-list').length) {
      // Scrollbar.init(document.querySelector('.product ul.product__media-list'), options);
    }

    if ($('.mob-slider').length) {
      Scrollbar.init(document.querySelector('.mob-slider'), options);
    }

    if ($('.product ul.product-grid').length) {
      Scrollbar.init(document.querySelector('.product ul.product-grid'));
    }

    // if($('div.block-logos').length) {
    //     Scrollbar.init(document.querySelector('div.block-logos'));
    // }

    //   Scrollbar.init(document.querySelector('ul.multicolumn-list'));
    // }
    // if($('ul.metas-products').length) {
    //   Scrollbar.init(document.querySelector('ul.metas-products'));
    // }

  } else {
    var Scrollbar = window.Scrollbar;
    if ($('.mob-slider').length) {
      Scrollbar.init(document.querySelector('.mob-slider'));
    }


  }
}


// = = = = = WIDGET = = = = = // document.addEventListener('rebuy.init', function(event){ console.log('rebuy.init event', event.detail); });


document.addEventListener('rebuy.ready', function (event) {

  $('.rebuy-product-review').prev('.rebuy-variant-title').addClass('has-reviews');


});

$(window).on('load', function () {
  setTimeout(priceChange, 1000);

  function priceChange() {
    var price = '';
    var price = $('#rebuy-widget-49199 .rebuy-product-price .rebuy-money.compare-at').html();
    var button = $('#rebuy-widget-49199 .rebuy-button>span').html();
    $('#rebuy-widget-49199 .rebuy-button>span').html('');
    $('#rebuy-widget-49199 .rebuy-button>span').html(price + ' | ' + button);

    $('.rebuy-cart__flyout-empty-cart a').removeAttr('target');
  }


  $('body.product input[type="radio"]').on('click', function () {
    setTimeout(updatePrice, 1000);

    function updatePrice() {
      var newPrice = $('.title-price').html();
      console.log(newPrice);
      $('.button-price').html(newPrice);

    }
  });


  setTimeout(updateStickyCta, 10);
	
	function updateStickyCta() {
		var klaviyo = $('.product-form__buttons .klaviyo-bis-trigger');
		var klaviyoIsDisabled = klaviyo.is('[data-bis-disabled="true"]');
		var buttonText = $('.product-form__buttons  button[type="submit"] > span').text();

		if ((klaviyo.is(':visible') || buttonText === 'Sold out') && !klaviyoIsDisabled) {
			$('.product-form__buttons  button[type="submit"]').hide();
			$('.sticky-cta-button').hide();
			$('.klaviyo-bis-trigger').show();
		} else {
			$('.sticky-cta-button').show();
			$('.product-form__buttons  button[type="submit"]').show();
			$('.klaviyo-bis-trigger').hide();
		}
	}


  // REORDER SORT BY
 // $('select[name="sort_by"] option:eq(2)').insertBefore($('select[name="sort_by"] option:eq(0)'));
 //$('select[name="sort_by"] option:eq(3)').insertBefore($('select[name="sort_by"] option:eq(1)'));
 // $('select[name="sort_by"] option:eq(4)').insertBefore($('select[name="sort_by"] option:eq(2)'));

});


document.addEventListener('rebuy:smartcart.ready', function(event){
	setTimeout(cartPriceChange, 1000);
	function cartPriceChange() {
		var price = '';
		var price = $('.rebuy-cart__flyout-subtotal-amount').html();
		var button = $('.rebuy-cart__checkout-button>span').html();
		$('.rebuy-cart__checkout-button>span').html('');
		$('.rebuy-cart__checkout-button>span').html(price + ' | ' + button);
	}
});


// document.addEventListener('rebuy:smartcart.show',function(event){
// // COUNT SAMPLES, IF TWO ARE IN CART, THEN HIDE WIDGET SO NO MORE CAN BE ADDED
//       console.log(event);
//       var cartItems = event.detail.smartcart.cart.items;
//       var cartTotal = Math.round(event.detail.smartcart.cart.total_price * 0.01);

//       var sampleCount = [];


//       $.each( cartItems, function( index, item ){
//         if(item.product_type == 'sample') {
//           sampleCount.push(item.id);
//         }

//       });
//       console.log('sample count', sampleCount);
//       if(sampleCount.length >= 2) {
//           $('#rebuy-widget-54183').fadeOut();
//       } else {
//           $('#rebuy-widget-54183').fadeIn();
//       }


// })
function hideRecommendationProduct() {
	if (!Rebuy.SmartCart.hasItems()) {
		document.querySelectorAll('[data-rebuy-component="notes"]').forEach((element) => {
			element.style.display = 'none';
		});
		document.querySelectorAll('[data-rebuy-component="cross-sell-widget"]').forEach((element) => {
			element.style.display = 'none';
		});
	} else {
		document.querySelectorAll('[data-rebuy-component="notes"]').forEach((element) => {
			element.style.display = 'block';
		});
		document.querySelectorAll('[data-rebuy-component="cross-sell-widget"]').forEach((element) => {
			element.style.display = 'block';
		});
	}
}

function setFreeMessage() {
  const cartItems = [...document.querySelectorAll(".rebuy-cart__flyout-item")];

  cartItems
    .forEach(cartItem => {
      if (cartItem.querySelector(".free-message")) return;

      const cartItemPrice = cartItem.querySelector(".rebuy-cart__flyout-item-price > div");

      if (cartItemPrice) cartItemPrice.insertAdjacentHTML("afterend", `<div class="rebuy-money sale free-message">FREE</div>`);
    });
}

document.addEventListener('rebuy:smartcart.show', function (event) {
  setTimeout(() => {
		setFreeMessage();
  }, 500);
   hideRecommendationProduct();

	const cartItemCount = event.detail.smartcart.cart.item_count;
	const cartTitle = document.querySelector('.rebuy-cart__title');

	if (cartTitle) {
		let countSpan = cartTitle.querySelector('.rebuy-cart__flyout-title--count');

		if (!countSpan) {
			countSpan = document.createElement('span');
			countSpan.className = 'rebuy-cart__flyout-title--count';
			cartTitle.appendChild(countSpan);
		}

		countSpan.textContent = `${cartItemCount}`;
	}

  // COUNT SAMPLES, IF TWO ARE IN CART, THEN HIDE WIDGET SO NO MORE CAN BE ADDED
//  console.log(event);
//  var cartItems = event.detail.smartcart.cart.items;
//  var cartTotal = Math.round(event.detail.smartcart.cart.total_price * 0.01);
//
//  var sampleCount = [];
//
//  $.each(cartItems, function (index, item) {
//    if (item.product_type == 'sample') {
//      sampleCount.push(item.id);
//    }
//
//  });
//  $('#rebuy-widget-54183').hide();
//  console.log('sample count', sampleCount);
//  if (sampleCount.length >= 2) {
//    $('#rebuy-widget-54183').fadeOut();
//  } else {
//    $('#rebuy-widget-54183').fadeIn();
//  }
//
//  if (sampleCount.length > 2) {
//    $.each(sampleCount, function (index, item) {
//      console.log(index);
//      if (index > 1) {
//        removeItem(item);
//      }
//    });
//    document.dispatchEvent(new CustomEvent('rebuy:cart.ready'));
//
//    function removeItem(id) {
//      $.ajax({
 //       type: "POST",
 //       url: "/cart/change.js",
 //       dataType: "json",
//        data: {
//          id: parseFloat(id),
//          quantity: 0,
//        },
//      }).then((data) => {
//        console.log('removed');
//      });
//    }
//
//    $('#rebuy-widget-54183').fadeOut();
//  }
//
//  if (cartTotal <= 50) {
//    $.each(sampleCount, function (index, item) {
//      removeItem(item);
//    });
//    document.dispatchEvent(new CustomEvent('rebuy:cart.ready'));
//
//
 //   function removeItem(id) {
//      $.ajax({
//        type: "POST",
//        url: "/cart/change.js",
//        dataType: "json",
//        data: {
//          id: parseFloat(id),
//          quantity: 0,
//        },
//      }).then((data) => {
//        console.log('removed');
//      });
//     }
//
//    $('#rebuy-widget-54183').fadeIn();
//  }
//  setTimeout(priceChange, 500);
  
  document.addEventListener('rebuy:cart.change', function (event) {
		 hideRecommendationProduct(); 
		setTimeout(() => {
			priceChange();
			setFreeMessage();
		}, 500);
  });
  
   function priceChange() {

    $('.rebuy-cart__flyout-empty-cart a').removeAttr('target');
    var price = '';
    var price = $('.rebuy-cart__flyout-subtotal-amount').html();
    $('.rebuy-cart__checkout-button>span').html($('.rebuy-cart__flyout-subtotal-amount').html() + ' |  CHECKOUT');

		const cartItemCount = event.detail.smartcart.cart.item_count;
		const cartTitle = document.querySelector('.rebuy-cart__title');

		 if (cartTitle) {
			 let countSpan = cartTitle.querySelector('.rebuy-cart__flyout-title--count');

			 if (!countSpan) {
				 countSpan = document.createElement('span');
				 countSpan.className = 'rebuy-cart__flyout-title--count';
				 cartTitle.appendChild(countSpan);
			 }

			 countSpan.textContent = `${cartItemCount}`;
		 }
  }

});
// document.addEventListener('rebuy:cart.add', function(event){

//   console.log('rebuy event listener');
//   this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//   const cartLink = document.querySelector('#cart-icon-bubble');
//   this.cart.open(cartLink);

// });

// IF PDP IS DUO / HAS VARIANTS


// CUSTOM SWATCHES JS

$('button.swatch').on('click', function () {
  $(this).addClass('selected');
  $('button.swatch').not(this).removeClass('selected');
  var value = $(this).data('value');
  var description = $(this).data('fragrance-note');
  $("input[value='" + value + "']").click();
  $('.fragrance-notes .fragrance-title').html(value);
  $('.fragrance-notes .fragrance-description').html(description);

  $('.sticky-cta-button>span').html('Add to bag');
  $('.sticky-cta-button').removeClass('disabled');
  // $('.sticky-cta-button>span').html('Make a Selection');


  setTimeout(updateStickyCta, 500);

	function updateStickyCta() {
		var klaviyo = $('.product-form__buttons .klaviyo-bis-trigger');
		var klaviyoIsDisabled = klaviyo.is('[data-bis-disabled="true"]');
		var buttonText = $('.product-form__buttons  button[type="submit"] > span').text();

		if ((klaviyo.is(':visible') || buttonText === 'Sold out') && !klaviyoIsDisabled) {
			$('.product-form__buttons  button[type="submit"]').hide();
			$('.sticky-cta-button').hide();
			$('.klaviyo-bis-trigger').show();
		} else {
			$('.sticky-cta-button').show();
			$('.product-form__buttons  button[type="submit"]').show();
			$('.klaviyo-bis-trigger').hide();
		}
	}

});



$('input[type="radio"]').on('click', function () {

  $('.sticky-cta-button>span').html('Add to bag');
  $('.sticky-cta-button').removeClass('disabled');

});

$('button.swatch').on('mouseenter', function () {
  $(this).addClass('active');
  $('button.swatch').not(this).removeClass('active');
  var value = $(this).data('value');
  var description = $(this).data('fragrance-note');
  // $("input[value='"+value+"']").click();
  $('.fragrance-notes .fragrance-title').html(value);
  $('.fragrance-notes .fragrance-description').html(description);

});

$('button.swatch').on('mouseleave', function () {
  $('button.swatch').not(this).removeClass('active');
  $(this).removeClass('active');
  var value = $('button.swatch.selected').data('value');
  var description = $('button.swatch.selected').data('fragrance-note');
  // $("input[value='"+value+"']").click();
  $('.fragrance-notes .fragrance-title').html(value);
  $('.fragrance-notes .fragrance-description').html(description);

});

$(document).on('click', '#rebuy-widget-52151', function (e) {
  e.preventDefault();
  e.stopPropagation();
  // var target = $('#rebuy-widget-52151 .rebuy-product-title').attr('href').match(/\d+/);
  var target = $('#rebuy-widget-52151 .rebuy-product-title').attr('href').match(/\d+/);
  console.log(target);
  $('.ghost-form form').attr('id', 'quick-add-' + target[0]);
  $('.ghost-form form input[name="id"]').val(parseInt(target[0]));
  $('.ghost-form form button').click();

});


$('form#FacetFiltersFormMobile .mobile-facets__inner>svg').on('click', function (event) {
  $('.mobile-facets__open-wrapper').trigger('click');
  console.log('clicked');
});


/*--------VIDEO SET DESKTOP AND MOBILE SOURCE-------*/
//get all vids
var video = document.querySelectorAll('video')

//add source to video tag
function addSourceToVideo(element, src) {
  var source = document.createElement('source');
  source.src = src;
  source.type = 'video/mp4';
  console.log(src);
  element.appendChild(source);
}

//determine screen size and select mobile or desktop vid
function whichSizeVideo(element, src) {
  var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
  if (windowWidth > 820) {
    addSourceToVideo(element, src.dataset.desktopVid);
  } else {
    addSourceToVideo(element, src.dataset.mobileVid);
  }
}

function updatePrice() {
  var prices = document.querySelectorAll(`.title-priceprc`);


  if (!prices) return;

  for (var each of prices) {
    each.innerText = each.innerText.replace('.00', '');
  }
}

//init only if page has videos
function videoSize() {
  if (video !== undefined) {
    video.forEach(function (element, index) {
      whichSizeVideo(
        element, //element
        element  //src locations
      );
    });
  }
}

videoSize();

window.onload = function () {
  setTimeout(updatePrice, 50);
}

$(document).ready(function () {
  function initConnectedProductsSwatches() {
    const $wrapper = $('.connected-products_swatches');
    const $grid = $wrapper.find('.connected-products_swatches-grid');
    const $contentInner = $wrapper.find('.connected-products__current-swatches-info');
    const $swatch = $grid.find('.connected-products_swatches__item');

    $grid.on('mouseleave', function (evt) {
      const $currentSwatch = $grid.find('.connected-products_swatches__item.current');
      const $currentSwatchContent = $currentSwatch.find('.connected-products__swatches-info');

      $contentInner.html($currentSwatchContent.html());
    });

    $swatch.on('mouseenter', function (evt) {
      const $this = $(this);
      const $thisSwatchContent = $this.find('.connected-products__swatches-info');

      console.log($thisSwatchContent);

      $contentInner.html($thisSwatchContent.html());
    });
  }

  if ($('.connected-products_swatches').length) initConnectedProductsSwatches();
  
  const live_url = window.location.href;
  const result = live_url.includes('form_type=customer');
  const input_val = document.querySelector('#NewsletterForm--footer').value;
  
  if(result && input_val) {
    const add_ele = document.createElement("h3");
    add_ele.innerText = "Email already subscribed.";
    document.querySelector('.newsletter-form__field-wrapper').appendChild(add_ele);
    add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
  }
}); 


document.addEventListener('DOMContentLoaded', function () {
	var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) {
		window.addEventListener('gorgias-widget-loaded', function () {
			resolve();
		});
	});

	initGorgiasChatPromise.then(function () {
		var timer = setInterval(function () {
			var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
			if (!chatButtonHead?.children.length) {
				return;
			}
			clearInterval(timer);

			var chatButtonIframe = document.querySelector('#chat-button');
			chatButtonIframe.style = "display:none;";
			var myButton = document.querySelector('#gorgias-chat__button');
			if (myButton) {
				myButton.onclick = function () {
					if (GorgiasChat.isOpen()) {
						GorgiasChat.close();
					} else {
						GorgiasChat.open();
					}
				}
			};

			document.addEventListener('click', function (event) {
				var chatContainer = document.querySelector('#gorgias-chat-container');
				if (GorgiasChat.isOpen() && !myButton.contains(event.target) && !chatContainer.contains(event.target)) {
					GorgiasChat.close();
				}
			});
		}, 50);
	});
});
